import { Link } from "react-router-dom";
import {
  PRIVACY_POLICY_PATH,
  TERMS_OF_SERVICE_PATH,
} from "../../utils/constants/externalLinks";

const linkClass = "text-brand-600 hover:underline";

// Both links always open in a separate window so the user never loses the form they are on.
const LegalLinks = ({ separator = " and " }) => (
  <>
    <Link
      to={PRIVACY_POLICY_PATH}
      target="_blank"
      rel="noopener noreferrer"
      className={linkClass}
    >
      Privacy Policy
    </Link>
    {separator}
    <Link
      to={TERMS_OF_SERVICE_PATH}
      target="_blank"
      rel="noopener noreferrer"
      className={linkClass}
    >
      Terms of Service
    </Link>
  </>
);

export default LegalLinks;
